import axios from "axios";
import React, { useEffect, useState } from "react";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import SmallLoader from "../../../Components/Common/smallLoader";
import { Constants } from "../../../CommonMethhods/Constants";
import Loader from "../../../Components/Common/Loader";
import LTCGReportTable from "../../../Components/ReportTables/LTCGRportTable";
import warningIcon from "../../../asset/images/icons/warning.svg";
import { Col, Row, Toast } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../../CommonMethhods/CommonMethods";

function LtcgReportNew(props) {
  const seg = "stocks";
  const storeToken = localStorage.getItem("ssoToken");
  // const [fileType, setFileType] = useState("grid");
  const [data, setData] = useState("");
  const [loader, setLoader] = useState(true);
  const [smallLoader, setSmallLoader] = useState({
    mail: false,
    pdf: false,
    excel: false,
  });
  const ClientId2 = localStorage.getItem("ClientId2");

  const [serverError, setServerError] = useState("");

  let clientCode = "";

  const getLtcgReports = async (clientCode, fileType) => {
    if (fileType == "excel") {
      setSmallLoader({ mail: false, pdf: false, excel: true });
    } else if (fileType == "pdf") {
      setSmallLoader({ mail: false, pdf: true, excel: false });
    } else if (fileType == "mail") {
      setSmallLoader({ mail: true, pdf: false, excel: false });
    } else {
      setSmallLoader({ mail: false, pdf: false, excel: false });
    }
    let payloadValue = {
      clientCode: clientCode || ClientId2,
      fileType: fileType,
      seg: seg,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axios.post(
        Dashboard_Client_Report.LtcgReport_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getDetails?.data);

      if (res?.data) {
        if (fileType == "grid") {
          setData(res?.data?.dysList);
        } else if (fileType == "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileType == "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        } else {
          toast.success("Mail sent successfully");
        }
      } else {
        setData([]);
        if (fileType == "excel") {
          toast.error("Days To Long Term Report does not exist");
        } else if (fileType == "pdf") {
          toast.error("Days To Long Term Report does not exist");
        } else if (fileType == "mail") {
          toast.error("Days To Long Term Report does not exist");
        }
      }
      setLoader(false);
      setSmallLoader({ mail: false, pdf: false, excel: false });
    } catch (error) {
      console.log(error);
      setLoader(false);

      setServerError("Something went wrong, Please try again later.");
      if (fileType == "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType == "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType == "mail") {
        toast.error("Something went wrong, Please try again later.");
      }
    } finally {
      setSmallLoader({ mail: false, pdf: false, excel: false });
    }
  };

  useEffect(() => {
    if (localStorage.getItem("clientCode") || ClientId2) {
      getLtcgReports(localStorage.getItem("clientCode"), "grid");
    }
    // setFileType("");
  }, []);

  const handleOnClick = (e) => {
    // setFileType("");
    setServerError("");
    if (e.target.value) {
      // setFileType(e.target.value);
      getLtcgReports(localStorage.getItem("clientCode"), e.target.value);
    }
  };
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="ltcg-report"
        role="tabpanel"
        aria-labelledby="ltcg-report"
      >
        <div className="reports-date-filter">
          <button
            className="generate-button mail-btn"
            value="mail"
            onClick={handleOnClick}
          >
            {smallLoader["mail"] ? (
              // <div>
              <SmallLoader />
            ) : (
              <>
                <span className="icon-email"></span>
                E-Mail
              </>
            )}
          </button>

          <button
            className="generate-button excel-btn"
            value="excel"
            onClick={handleOnClick}
          >
            {smallLoader["excel"] ? (
              <div>
                <SmallLoader />
              </div>
            ) : (
              <>
                <span className="icon-excelsvg"></span>
                {Constants.Excel}
              </>
            )}
          </button>
          <button
            className="generate-button pdf-btn"
            value="pdf"
            onClick={handleOnClick}
          >
            {smallLoader["pdf"] ? (
              <div>
                <SmallLoader />
              </div>
            ) : (
              <>
                <span className="icon-pdfsvg"></span>
                {Constants.PDF}
              </>
            )}
          </button>
        </div>
      </div>
      <div>
        {" "}
        {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : data ? (
          <div>
            <LTCGReportTable data={data} />
          </div>
        ) : serverError === "Something went wrong, Please try again later." ? (
          <h4 className="report-table-wrapper">{serverError}</h4>
        ) : (
          ""
        )}
      </div>
    </>
  );
}
export default LtcgReportNew;
